import { render, staticRenderFns } from "./aspect-menu-component.vue?vue&type=template&id=7d3204ff&scoped=true&"
import script from "./aspect-menu-component.vue?vue&type=script&lang=ts&"
export * from "./aspect-menu-component.vue?vue&type=script&lang=ts&"
import style0 from "./aspect-menu-component.vue?vue&type=style&index=0&id=7d3204ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3204ff",
  null
  
)

export default component.exports